import { join } from 'light-component';
import * as Base from '@base';
import { Box } from '@common';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import type { ReactElement } from 'react';
import type { ShotEyesUserProps } from './types';

export function ShotEyesUserViewMode(props: ShotEyesUserProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter title={props.title} keyword={props.keyword} className={styles.title} />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Base.Input
          type='text'
          readOnly={true}
          value={props.value}
        />
      </Box>
    </Box>
  );
}
